export const DONATE_OPEN_EVENT = "avt:open-donate";

export function stripDonateHash() {
  if (typeof window === "undefined") return;
  try {
    const url = new URL(window.location.href);
    if (!url.hash) return;
    window.history.replaceState(null, "", `${url.pathname}${url.search}`);
  } catch {
    /* ignore */
  }
}

export function openDonateModal() {
  if (typeof window === "undefined") return;
  stripDonateHash();
  window.dispatchEvent(new Event(DONATE_OPEN_EVENT));
}
